
const Contactanos = () => {
  return (
    <div>Contactanos</div>
  )
}

export default Contactanos